import React from "react";
import { Spinner } from "react-bootstrap";

const GenerateButton = ({
  buttonLabel = 'Write with AI',
  isSmall = false,
  buttonStyle = isSmall ? 'hg-purple-btn-small' : 'hg-purple-btn',
  buttonStyleLoading = isSmall ? 'hg-purple-btn-small-loading' : 'hg-purple-btn-loading',
  iconRoute = '/images/generate-icon.svg',
  loading,
  onButtonClick = () => { },
  disabled = false
}) => {

  return (
    <span className={`${loading ? buttonStyleLoading : buttonStyle}`} onClick={() => { if (!disabled) onButtonClick() }}>
      {loading ? (
        <Spinner
          animation="border"
          size="sm"
          color="#5244B3"
          className="mr-1"
          style={{ width: `${isSmall ? '10' : '14'}px`, height: `${isSmall ? '10' : '14'}px` }}
        />
      ) : (
        <img alt="" src={iconRoute} width={isSmall ? 10 : 14} height={isSmall ? 10 : 14} className="mr-1" />
      )}
      {buttonLabel}
    </span>
  );
};

export default GenerateButton;